import React, { lazy } from 'react';
import { Route } from 'react-router';
import ValidatedRoute from 'chameleon-src/utility/validatedRoute';

import TimedAssignmentWrapper from 'chameleon/src/components/wrappers/TimedAssignmentWrapper';
import BlueBookRouteWrapper from 'chameleon/src/components/wrappers/BlueBookRouteWrapper';

const StudentPlayer = lazy(
  () => import('legacy/src/components/apstudent/handlers/Player'),
);

const BlueBookStudentPlayer = lazy(
  () => import('chameleon-src/components/blueBook/StudentPlayer'),
);

const StudentSPPPlayer = lazy(
  () => import('chameleon/ui-stack/ui/spp/player/student'),
);
const SPPReviewPlayer = lazy(
  () => import('chameleon/ui-stack/ui/spp/player/review'),
);
const WorldLanguagePilotPlayer = lazy(
  () => import('chameleon/ui-stack/ui/world_language_pilot/player'),
);

export default (
  <Route path=":subject">
    <Route
      name="player"
      path="assessments/assignments/:assignmentId"
      component={BlueBookRouteWrapper(
        TimedAssignmentWrapper(ValidatedRoute(StudentPlayer)),
      )}
      blueBookComponent={ValidatedRoute(BlueBookStudentPlayer)}
      hideTopBar
      exact
    />
    <Route
      name="player"
      path="assessments/spp/:assignmentId"
      component={ValidatedRoute(StudentSPPPlayer)}
      hideTopBar
      exact
    />
    <Route
      name="review-player"
      path="assessments/spp/review/:assignmentId"
      component={ValidatedRoute(SPPReviewPlayer)}
      hideTopBar
      exact
    />
    <Route
      name="world-language-pilot-player"
      path="assessments/world-language-pilot/:activityId"
      component={ValidatedRoute(WorldLanguagePilotPlayer)}
      hideTopBar
      exact
    />
  </Route>
);
